// Home page sections: shared by the storefront (Home.jsx) and the admin Page Builder.

export const DEFAULT_ORDER = [
  'hero', 'trust_bar', 'promotions', 'category_grid', 'deals_section', 'featured_section', 'best_sellers',
  'bundles_section', 'new_arrivals', 'countdown_banner', 'collections', 'top_rated', 'recently_viewed',
  'products_section', 'newsletter',
];

export const SECTION_DEFAULTS = {
  hero: { enabled: true, badge_text: 'New finds every week', title_line1: 'Quality goods', title_line2: 'for everyday life',
    description: 'Thoughtfully chosen products at honest prices, shipped fast to your door.', cta_text: 'Start shopping', cta_link: '#products', image: '' },
  trust_bar: { enabled: true, item1: 'Fast, tracked shipping', item2: 'Secure checkout', item3: 'Hand-picked quality', item4: 'Friendly support' },
  promotions: { enabled: true },
  category_grid: { enabled: true, title: 'Shop by category', subtitle: 'Find exactly what you\'re looking for' },
  deals_section: { enabled: true, title: 'Today\'s deals', subtitle: 'Limited-time prices. Don\'t miss out', max_items: 10 },
  featured_section: { enabled: true, title: 'Featured picks', subtitle: 'Hand-picked by our team', max_items: 8, show_view_all: true },
  best_sellers: { enabled: true, title: 'Best sellers', subtitle: 'What everyone\'s buying right now', max_items: 10 },
  bundles_section: { enabled: true, title: 'Better together', subtitle: 'Bundle up and save' },
  new_arrivals: { enabled: true, title: 'Just landed', subtitle: 'Fresh arrivals you haven\'t seen yet', max_items: 12 },
  countdown_banner: { enabled: false, title: 'Flash Sale!', subtitle: 'Limited time offer', end_date: '', cta_text: 'Shop now', cta_link: '/sale' },
  collections: { enabled: true, title: 'Curated collections', subtitle: 'Hand-picked sets for every style' },
  top_rated: { enabled: true, title: 'Top rated', subtitle: 'Loved by our customers', max_items: 10 },
  recently_viewed: { enabled: true, title: 'Recently viewed' },
  products_section: { enabled: true, title: 'Explore everything', show_search: true, show_categories: true },
  newsletter: { enabled: true, title: 'Get 10% off your first order', subtitle: 'Join the hive for exclusive deals, new arrivals and gift ideas',
    button_text: 'Subscribe', incentive_badge: '10% OFF', placeholder: 'Enter your email' },
};

/** Keep the saved order, and slot any sections added since it was saved next to their default neighbours. */
export function mergeOrder(saved) {
  const order = (saved && saved.length ? saved : DEFAULT_ORDER).filter(id => DEFAULT_ORDER.includes(id));
  DEFAULT_ORDER.forEach((id, i) => {
    if (order.includes(id)) return;
    const before = DEFAULT_ORDER.slice(0, i).reverse().find(prev => order.includes(prev));
    order.splice(before ? order.indexOf(before) + 1 : 0, 0, id);
  });
  return order;
}

/** Fill in defaults for sections the saved config doesn't have yet. */
export function withDefaults(cfg = {}) {
  const out = { ...cfg };
  Object.entries(SECTION_DEFAULTS).forEach(([id, def]) => { out[id] = { ...def, ...(cfg[id] || {}) }; });
  out.sections_order = mergeOrder(cfg.sections_order);
  return out;
}
